export const buildWhatsAppLink = (number: string, message: string): string => {
  const digits = number.replace(/\D/g, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${digits}?text=${encodedMessage}`;
};
